import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as config from "../../../../constants/config";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as navigationActions from "../../../../actions/navigationActions";
import * as resources from "../../../../constants/resources";
import * as rccActions from "../../../../actions/rccActions";
import * as rcc from "../../../../constants/rcc";
import * as settingsActions from "../../../../actions/settingsActions";
import * as validationHelper from "../../../../helpers/validationHelper";

import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Modal from "../../../global/generic/Modal";
import NumericKeyboardInput from "../../../global/NumericKeyboardInput";

import imgRecirculate from "../../../../resources/img/svgicons/recirculate.svg";

class RecirculateChannelsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedChannels: [],
            recirculatingTime: this.props.recirculatingTime,
            recirculatingSpeed: this.props.recirculatingSpeed
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleSelectAllClick = () => {
        this.setState({
            selectedChannels: this.getEnabledChannels()
        });
    };

    handleClearClick = () => {
        this.setState({
            selectedChannels: []
        });
    };

    handleToggleSelectChannelClick = (event) => {
        let channel = this.getChannelFromList(Number(event.target.dataset.id));

        if (channel !== null) {
            if (this.isChannelSelected(channel)) {
                this.setState({
                    selectedChannels: this.state.selectedChannels.filter((selected) => selected.id !== channel.id)
                });
            } else {
                this.setState({
                    selectedChannels: [...this.state.selectedChannels, channel]
                });
            }
        }
    };

    handleStartRecirculatingClick = () => {
        let channelIndexes = this.state.selectedChannels.map((channel) => channel.id);

        if (channelIndexes.length > 0) {
            this.props.dispatchRecirculateChannelsAction(
                channelIndexes,
                this.state.recirculatingTime,
                this.state.recirculatingSpeed
            );
        }
    };

    handleRecirculateTimeFocus = (event) => {
        event.target.select();
    };

    handleRecirculateSpeedFocus = (event) => {
        event.target.select();
    };

    handleRecirculatingSpeedChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                recirculatingSpeed: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleRecirculatingTimeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                recirculatingTime: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleRecirculatingSpeedBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value <= 100 && value >= 1) {
            this.setState({recirculatingSpeed: formatHelper.formatDecimal(value)});
            this.props.dispatchSetRecirculationSpeedAction(parseInt(formatHelper.formatDecimal(value)));
        } else {
            this.setState({recirculatingSpeed: this.props.recirculatingSpeed});
        }
    };

    handleRecirculatingTimeBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value >= rcc.RCC_MINIMAL_RECIRCULATE_TIME) {
            this.setState({recirculatingTime: formatHelper.formatDecimal(value)});
            this.props.dispatchSetRecirculationTimeAction(parseInt(formatHelper.formatDecimal(value)));
        } else {
            this.setState({recirculatingTime: rcc.RCC_MINIMAL_RECIRCULATE_TIME});
            this.props.dispatchSetRecirculationTimeAction(rcc.RCC_MINIMAL_RECIRCULATE_TIME);
        }
    };

    getEnabledChannels = () => {
        return this.props.channelList.filter((channel) => channel.enabled);
    };

    getChannelFromList = (channelId) => {
        let channel;
        for (channel of this.props.channelList) {
            if (channel.id === channelId) {
                return channel;
            }
        }

        return null;
    };

    isChannelSelected = (channel) => {
        if (this.state.selectedChannels.length === 0) {
            return false;
        }

        let selectedChannel;
        for (selectedChannel of this.state.selectedChannels) {
            if (selectedChannel.id === channel.id) {
                return true;
            }
        }

        return false;
    };

    getColorantByChannel = (channel) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (channel.colorant.name === colorant.name) {
                return colorant;
            }
        }

        return null;
    };

    getChannelBoxClass = (channel) => {
        if (this.isChannelSelected(channel)) {
            return "colorant-box active";
        }

        return "colorant-box";
    };

    getChannelBox = (channel) => {
        let colorant = channel.colorant;
        if (colorant !== null && colorant.rgb === null) {
            colorant = this.getColorantByChannel(channel);
        }

        if (!channel.enabled) {
            return (
                <div key={channel.id} className="colorant-box disabled">
                    <div key={channel.id} className="color-primary canister-index">
                        {channel.id}
                    </div>
                    <div
                        className="colorant-square"
                        style={{backgroundColor: colorant !== null ? colorant.rgb : config.DEFAULT_RGB}}
                    />
                    <div className="colorant-code">{colorant !== null ? colorant.name : ""}</div>
                </div>
            );
        }

        return (
            <div
                key={channel.id}
                className={this.getChannelBoxClass(channel)}
                data-id={channel.id}
                onClick={this.handleToggleSelectChannelClick}
            >
                <div
                    key={channel.id}
                    data-id={channel.id}
                    onClick={this.handleToggleSelectChannelClick}
                    className="color-primary canister-index"
                >
                    {channel.id}
                </div>
                <div
                    className="colorant-square"
                    style={{backgroundColor: colorant !== null ? colorant.rgb : config.DEFAULT_RGB}}
                    data-id={channel.id}
                />
                <div className="colorant-code" data-id={channel.id}>
                    {colorant !== null ? colorant.name : ""}
                </div>
            </div>
        );
    };

    getChannelBox = (channel) => {
        let colorant = channel.colorant;
        if (colorant !== null && colorant.rgb === null) {
            colorant = this.getColorantByChannel(channel);
        }

        let channelRgb = colorant === null || colorant.rgb === null ? config.DEFAULT_RGB : colorant.rgb;
        let channelName = colorant === null || colorant.name === null ? "" : colorant.name;

        if (!channel.enabled) {
            return (
                <div key={channel.id} className="general-colorant-select-box disabled">
                    <div className="general-colorant-select-box-id" data-id={channel.id}>
                        {channel.id}
                    </div>
                    <div className="general-colorant-select-box-color" style={{backgroundColor: channelRgb}} />
                    <div className="general-colorant-select-box-name">{channelName}</div>
                </div>
            );
        }

        return (
            <div
                key={channel.id}
                className={"general-colorant-select-box " + this.getChannelBoxClass(channel)}
                data-id={channel.id}
                onClick={this.handleToggleSelectChannelClick}
            >
                <div className="general-colorant-select-box-id" data-id={channel.id}>
                    {channel.id}
                </div>
                <div
                    className="general-colorant-select-box-color"
                    style={{backgroundColor: channelRgb}}
                    data-id={channel.id}
                />
                <div className="general-colorant-select-box-name" data-id={channel.id}>
                    {channelName}
                </div>
            </div>
        );
    };

    getChannelsList = () => {
        return (
            <div className="general-wrapper-body general-colorant-select-box-wrapper slim-scroll">
                {this.props.channelList.map(this.getChannelBox)}
            </div>
        );
    };

    getStartRecirculatingButton = () => {
        return (
            <Button
                svgBefore={imgRecirculate}
                onClick={this.handleStartRecirculatingClick}
                label={<Translate value="serviceActionsSettings.recirculate" />}
                disabled={
                    !(
                        this.state.selectedChannels.length > 0 &&
                        Number(this.state.recirculatingTime) > 0 &&
                        Number(this.state.recirculatingSpeed) > 0
                    )
                }
            />
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex font-size-2rem margin-bottom-10 flex-align-center-vertical">
                    <Translate value="recirculateChannels.recirculatingSpeed" />
                    &nbsp;
                    <NumericKeyboardInput
                        type="text"
                        className="general-input primary-input width-60px text-center"
                        value={this.state.recirculatingSpeed}
                        onFocus={this.handleRecirculateSpeedFocus}
                        onChange={this.handleRecirculatingSpeedChange}
                        onBlur={this.handleRecirculatingSpeedBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.SETTINGS_RECIRCULATION_SPEED)}
                        extended={false}
                        setInputState={this.setRecirculationSpeed}
                    />
                    <span className="margin-right-auto" style={{marginLeft: "5px"}}>
                        %
                    </span>
                    <Translate value="recirculateChannels.recirculatingTime" />
                    &nbsp;
                    <NumericKeyboardInput
                        type="text"
                        className="general-input primary-input width-60px text-center"
                        value={this.state.recirculatingTime}
                        onFocus={this.handleRecirculateTimeFocus}
                        onChange={this.handleRecirculatingTimeChange}
                        onBlur={this.handleRecirculatingTimeBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.SETTINGS_RECIRCULATION_TIME)}
                        extended={false}
                        setInputState={this.setRecirculationTime}
                    />
                    <span style={{marginLeft: "5px"}}>s</span>
                </div>
                <div className="general-wrapper flex-child">
                    <div className="general-wrapper-header flex margin-bottom-10 flex-align-center-vertical">
                        {translate("general.selectChannels")}
                        <Button
                            className="margin-left-auto"
                            onClick={
                                this.state.selectedChannels.length < this.getEnabledChannels().length
                                    ? this.handleSelectAllClick
                                    : this.handleClearClick
                            }
                            label={
                                this.state.selectedChannels.length < this.getEnabledChannels().length
                                    ? translate("general.selectAll")
                                    : translate("general.clear")
                            }
                        />
                    </div>
                    {this.getChannelsList()}
                </div>
            </React.Fragment>,
            "flex-column"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getStartRecirculatingButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="recirculateChannels.recirculateChannels" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        channelList: store.rcc.channelList,
        colorantList: store.global.colorantList,
        recirculatingSpeed: store.settings.recirculationSpeed,
        recirculatingTime: store.settings.recirculationTime,
        loggedUser: store.login.loggedUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.RECIRCULATE_CHANNELS_MODAL));
        },
        dispatchRecirculateChannelsAction: (channels, time, speed) => {
            dispatch(rccActions.recirculateChannels(channels, time, speed));
        },
        dispatchSetRecirculationTimeAction: (recirculationTime) => {
            dispatch(settingsActions.setRecirculationTime(recirculationTime));
        },
        dispatchSetRecirculationSpeedAction: (recirculationSpeed) => {
            dispatch(settingsActions.setRecirculationSpeed(recirculationSpeed));
        }
    };
};

export default RecirculateChannelsModal = connect(mapStoreToProps, mapDispatchToProps)(RecirculateChannelsModal);
